import request from '@/utils/request'
// 获取艺术家个人信息接口
export const getArtistInfo = (userId) => {
  return request({
    url: '/yslt-server-user/user/personalSpace',
    params: {
      userId
    }
  })
}
// 根据id获取艺术家作品接口
export const getArtistWorks = (userId) => {
  return request({
    url: '/yslt-server-admin/api/v1/appWorks/queryUserWorksListById',
    params: {
      userId
    }
  })
}
// 关注艺术家接口
export const attentionArtist = (userId) => {
  return request({
    url: '/api/v1/appUser/concernUser',
    params: {
      userId
    }
  })
}
// 取消关注艺术家接口
export const unfollow = (userId) => {
  return request({
    url: '/api/v1/appUser/cancelConcernUser',
    params: {
      userId
    }
  })
}

// 获取艺术家资讯
export const getInfoReport = (userId) => {
  return request({
    url: '/yslt-server-information/information-report/page',
    params: {
      userId
    }
  })
}

// 获取作品详情（新）
export const getWorksDetailById = (id) => {
  return request({
    url: '/yslt-server-admin/api/v1/appWorks/getDetailById',
    params: {
      id
    }
  })
}
